////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { map } from 'lodash'
///////COMPONENTS///////
import PagingList from './PagingList'
import { SelectInputWrapper, SelectInput } from '../../../../../theme/GlobalCss'

/////////STYLED/////////
const PagingSelectionWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(min-content, max-content));
	grid-column-gap: 15px;
	position: fixed;
	bottom: 0;
	left: 50px;
	width: max-content;
	height: 62px;
	box-shadow: 2px 0px 6px #00000029;
	border-radius: 0px 4px 0px 0px;
	z-index: 11;
	background-color: #fbfbfb;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
	font-size: ${(props) => props.theme.font.fs};
`
const SelectWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(5, minmax(min-content, max-content));
	grid-column-gap: 5px;
	justify-content: center;
	align-items: center;
`
const PagingWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(min-content, max-content));
	grid-column-gap: 10px;
	justify-content: center;
	align-items: center;
	border: 1px solid #e5e5e5;
	padding: 0 15px;
	border-radius: 4px;
	height: 50px;
`
const ArrowWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 32px;
	background-color: #e5e5e5;
	border-radius: 4px;
	cursor: pointer;
`
const LeftArrow = styled.div`
	border-right: 8px solid ${(props) => props.theme.colors.tabText};
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	transition: all 0.5s ease;
	transform: rotate(${(props) => (props.open ? 180 : 0)}deg);
`
const RightArrow = styled.div`
	border-left: 8px solid ${(props) => props.theme.colors.tabText};
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	transition: all 0.5s ease;
	transform: rotate(${(props) => (props.open ? 180 : 0)}deg);
`
/////////STYLED/////////

const PagingSelection = ({ totalPage, register, setValue, getValues, onSubmit }) => {
	let options = new Array(totalPage || 1)

	options = map(options, (_opt, key) => key + 1)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleNextPaging = () => {
		let page = Number(getValues('goToPage')) + 1 || 0

		if (totalPage - 1 < page) {
			return
		}

		setValue('goToPage', page.toString())
		setValue('tmpGoTo', page.toString())
		onSubmit(getValues())
	}

	const handlePrevPaging = () => {
		let page = Number(getValues('goToPage')) - 1 || 0

		if (0 > page) {
			return
		}

		setValue('goToPage', page.toString())
		setValue('tmpGoTo', page.toString())
		onSubmit(getValues())
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<PagingSelectionWrapper>
			<PagingWrapper>
				<ArrowWrapper onClick={handlePrevPaging}>
					<LeftArrow />
				</ArrowWrapper>
				<PagingList
					options={options}
					setValue={setValue}
					register={register}
					getValues={getValues}
					totalPage={totalPage}
					submitHandler={onSubmit}
				/>
				<ArrowWrapper onClick={handleNextPaging}>
					<RightArrow />
				</ArrowWrapper>
			</PagingWrapper>
			<SelectWrapper>
				<p>Aller à la page :</p>
				<SelectInputWrapper>
					<SelectInput name="goToPage" ref={register()}>
						{map(options, (opt, key) => (
							<option key={key} value={key}>
								{opt}
							</option>
						))}
					</SelectInput>
				</SelectInputWrapper>
			</SelectWrapper>
		</PagingSelectionWrapper>
	)
}

PagingSelection.propTypes = {}

PagingSelection.defaultPropTypes = {}

export default PagingSelection
